module.exports = __webpack_public_path__ + "97ea241e0e65f68356cff797a1243d10.svg";